'use client';

// import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  //   const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme="dark"
      gap={10}
      offset={20}
      position="bottom-left"
      className="toaster group"
      toastOptions={{
        style: {
          width: 300,
        },
        classNames: {
          toast:
            'group toast group-[.toaster]:rounded-lg group-[.toaster]:text-sm group-[.toaster]:px-3 group-[.toaster]:py-2 group-[.toaster]:bg-popover-elevated group-[.toaster]:text-white group-[.toaster]:shadow-lg ![height:auto]',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          content: '![height:auto]',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
